import * as React from "react";
import useViewer from "../../hooks/useViewer";
import { timeAgoLabel } from "../../utils/timeAgo";
import { Activity as ActivityType } from "../../graphql/types/base";
import { Link } from "../wombat-ui";
import useTranslations from "../../hooks/useTranslations";

interface Props {
  visual: React.ReactElement;
  activity: ActivityType;
  id: string;
}

const ActivityPlate: React.FC<Props> = ({
  visual,
  id,
  children,
  activity: { createdAt, owner },
}) => {
  const viewer = useViewer();
  const t = useTranslations();

  return (
    <div className="flex items-center">
      <span className="z-10 flex items-center justify-center w-8 h-8 rounded-full bg-light-0">
        {visual}
      </span>
      <div id={id} className="flex py-4 -ml-4 border-l-2 border-gray-200">
        <div className="px-12">
          {children}
          <div className="text-xs text-light-900">
            <time className="text-xs">{}</time>
            {t("activity.labels.by", {
              time: timeAgoLabel(createdAt),
              by: (
                <Link to={`/users/${owner.id}`} key={id}>
                  {viewer.id === owner.id
                    ? t("activity.labels.you")
                    : `${owner.name}`}
                </Link>
              ),
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityPlate;
